import { getAnalytics, logEvent } from 'firebase/analytics';
import { initializeApp } from 'firebase/app';

import { config } from '@/config/app.config';

interface Events {
  click_FAQs: { location: 'header' };
  click_download_app: { location: 'landingPage' | 'assetPageHeader' };
  type_search_bar: {
    userInput: string;
    assetNotFound: boolean;
    location: 'landingPage' | 'assetPageHeader';
  };
  click_clear_search: {
    userInput: string;
    location: 'landingPage' | 'assetPageHeader';
  };
  select_search_asset: {
    assetSearched: string;
    calendarChip: string;
    location: 'landingPage' | 'assetPageHeader';
  };
  click_calendar_chip: { calendarChip: string };
  click_whatIf: { location: 'landingPage' | 'assetPageHeader' };
  click_explore_more: { location: 'assetPageHeader' };
  click_eps_tab: {
    assetName: string;
    epsTab: 'beats' | 'misses';
    releaseDate: string;
  };
  show_earnings_chart_details: {
    assetName: string;
    cursorAction: 'click' | 'hover';
    action: 'show' | 'hide';
  };
  click_dig_in: {
    assetName: string;
    tab: 'beat' | 'miss' | 'meet';
    releaseStatus: 'Upcoming' | 'Released';
  };
  share_analysis: { assetName: string; platform: 'twitter' };
  click_close_x: { location: 'drawer' };
  click_sorting: {
    sortBy: 'earnings' | 'EPS surprise' | '1W' | '2W' | '1M';
    releaseStatus: 'Upcoming' | 'Released';
  };
  click_search_different: { assetName: string };
  click_try_again: {
    assetName: string;
    location: 'errorScreen';
  };
  press_cmd_plus_k: {
    location: 'landingPage' | 'assetPageHeader';
    companyPage: string;
  };
  press_down_arrow: {
    location: 'landingPage' | 'assetPageHeader';
    companyPage: string;
  };
  press_up_arrow: {
    location: 'landingPage' | 'assetPageHeader';
    companyPage: string;
  };
  press_tab: {
    location: 'landingPage' | 'assetPageHeader';
    companyPage: string;
    moveFocusTo: 'Chips' | 'Autocomplete List';
  };
  press_left_arrow: {
    location: 'landingPage' | 'assetPageHeader';
    companyPage: string;
  };
  press_right_arrow: {
    location: 'landingPage' | 'assetPageHeader';
    companyPage: string;
  };
  press_esc: {
    location: 'landingPage' | 'assetPageHeader';
    companyPage: string;
  };
  press_enter: {
    location: 'landingPage' | 'assetPageHeader';
    companyPage: string;
  };
}

export const createLogGA =
  (category: string) =>
  <T extends keyof Events>(eventName: T, eventParams: Events[T]) => {
    if (typeof window !== 'undefined') {
      if (config.isLocal) {
        // eslint-disable-next-line no-console
        console.log('Analytics', eventName, { category, ...eventParams });
        return;
      }

      const app = initializeApp(config.firebaseConfig);
      const analytics = getAnalytics(app);

      logEvent(analytics, eventName as string, { category, ...eventParams });
    }
  };
